import React from "react";
import { Box } from "@mui/material";
import useStyles from "assets/jss/material-react/views/italmundoStyles";

export function SinProductos(mobile) {
  const classes = useStyles();
  return (
    <Box className={classes.modalContentDynamic}>
      <p className={classes.modalMessage}>
        Actualmente{" "}
        <span style={{ color: "#d00771" }}>
          no tenemos productos que se adapten a tus necesidades.
        </span>
        <br />
        <br />
        ¡Te esperamos pronto!
      </p>
    </Box>
  );
}

export default SinProductos;
